import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { signOn, getPartenaire, getCguByPartenaireAndCode } from '../../api/api';
import SignOnForm from './SignOnForm';
import { pushToDataLayer } from '../../utils/gtmUtils';
export class SignOnPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validSignOn: false,
      errorMessage: '',
      spinner : 'inactive',
      ready: false,
      error: {
        contractNumber: '',
      }
    }
  }
  
  componentWillMount = () => {
	  getPartenaire().then((response) => {
		  let partenaire = response.data;
		  getCguByPartenaireAndCode(partenaire.data.id, 'CGU').then((response) => {
			  let cguId = response.data[0].id;
			  getCguByPartenaireAndCode(partenaire.data.id, 'CDC').then((response) => {
				  let cdcId = response.data[0].id;
				  this.setState({ partenaire : partenaire, cguId: cguId, cdcId, cdcId, ready: true })
			  });
		  });
	  });  
  }
  
  onSubmit = (data) => {
    const dataLayer = {
      event: "signOn",
      url: window.location.href,
      idPartenaire: this.props.partenaireData != null ? this.props.partenaireData.id: ""
    }
    pushToDataLayer(dataLayer);
    this.setState({ spinner: 'active' });
    signOn(data).then((response) => {
      setTimeout(() => {this.setState({ spinner: 'inactive' }) } , 500);
      if (response.data && response.data.code === "200") {
        this.setState(prevState => ({
          validSignOn: true,
          error: {
            ...prevState.error,
            contractNumber: ''  
          }
        }));
      } else {
        this.setState(prevState => ({
          errorMessage: 'Inscription non valide',
          error: {
            ...prevState.error,
            contractNumber: ' is-invalid'
          }
        }));
      }
    })
      .catch(function (error) {
        console.log('error', error);
      })
  };
  render() {
	  if ( !this.state.ready ) { return null }
    return (
      <div className="sign-on-main">
        <div className="page-background"></div>
        <div className="container sign-on-container form-container">
          <div className="bloc-form">
            <div className="bloc-form_container">
              <h2>S'inscrire</h2>
              {!this.state.validSignOn &&
                <div>
                  <SignOnForm
                    onSubmit={this.onSubmit}
                    error={this.state.error}
                    spinner ={this.state.spinner}
                  	cguId={this.state.cguId}
                  	cdcId={this.state.cdcId}
                  />
                </div>
              }

              {this.state.validSignOn &&
                <div className="bloc-from_success">
                  <img src='/images/yes.png' alt="image" />
                  <p className="validation-txt">
                  Votre inscription a été validée. <br />
                  Vous allez recevoir un mail de confirmation avec un lien d’activation de votre espace de recueil de mémoire.
                </p>
                </div>
              }
            </div>
            <div className="bloc-form_error">
              {this.state.error.contractNumber &&
                <div className="alert alert-danger" role="alert">
                  {this.state.errorMessage} <br/>
                  <span className="small-txt">Pour vérifier l'exactitude des éléments saisis, contactez le 01 40 25 57 32 ou <a href="mailto:ssp@votreassistance.fr">ssp@votreassistance.fr</a> </span>
                </div>
              }
            </div>
          </div>
          <div className="signon-container">
            <div className="col-sm-5 text-bloc">
              <h2>Déjà un compte ?</h2>
              <p className>Pour accéder au service, connectez-vous à l'aide de votre adresse email et de votre mot de passe</p>
              <Link to="/"><button type="button" className="btn btn-light btn-lg btn-login">Me connecter</button></Link>
            </div>
          </div>
        </div>
        <div className="container sign-on-container message-container">
    		<div className="bloc-message">
		        Les informations recueillies font l'objet d'un traitement informatique destiné à permettre à AP Solutions Gmbh, succursale française de traiter votre demande. Ces données sont conservées pendant 
		        la durée nécessaire à l'exécution du contrat et conformément aux dispositions relatives à la prescription. Elles sont destinées aux gestionnaires des prestations et sont 
		        susceptibles d'être communiquées à des sous-traitants, situés dans ou hors de l'Union Européenne.  Conformément à la  législation en vigueur, vous disposez d'un droit 
		        d'accès et d'opposition aux informations vous concernant en vous adressant à l’adresse mail suivante : 
		        <a href="mailto:informations-personnelles@votreassistance.fr">informations-personnelles@votreassistance.fr</a>. Nous vous informons de l'existence de la liste 
		        d'opposition au démarchage téléphonique « Bloctel » sur laquelle  vous pouvez vous inscrire : 
		        <a href="https://www.bloctel.gouv.fr/" target="_blank"> https://www.bloctel.gouv.fr/</a>. Pour plus d’informations, merci  de consulter la Charte de confidentialité.
		     </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (state) => ({
//   startLogin: (credentials) => dispatch(startLogin(credentials))
  partenaireData: state.partenaireData
});

//export default SignOnPage;

export default connect(undefined, mapDispatchToProps)(SignOnPage);



// WEBPACK FOOTER //
// ./src/components/SignOnPage/SignOnPage.js